import { Injectable, signal } from '@angular/core';
import { MedicalRecord } from '../models/medical-record.model';

@Injectable({
  providedIn: 'root'
})
export class MedicalRecordService {
  private records = signal<MedicalRecord[]>([]);

  constructor() {
    // Initialize with mock data
    this.records.set([
      {
        id: '1',
        patientId: '1',
        patientName: 'Alice Johnson',
        doctorId: '1',
        doctorName: 'Dr. Sarah Williams',
        date: new Date(),
        visitType: 'Consultation',
        chiefComplaint: 'Routine checkup',
        diagnosis: ['Healthy'],
        symptoms: [],
        vitalSigns: {
          bloodPressure: '120/80',
          heartRate: 72,
          temperature: 98.6,
          respiratoryRate: 16,
          weight: 65,
          height: 165,
          bmi: 23.9
        },
        examination: {
          general: 'Patient appears healthy',
          cardiovascular: 'Normal heart sounds',
          respiratory: 'Clear lungs'
        },
        recommendations: ['Continue healthy lifestyle', 'Annual checkup in 1 year'],
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ]);
  }

  getRecords() {
    return this.records.asReadonly();
  }

  getRecordById(id: string): MedicalRecord | undefined {
    return this.records().find(r => r.id === id);
  }

  getRecordsByPatient(patientId: string): MedicalRecord[] {
    return this.records().filter(r => r.patientId === patientId);
  }

  addRecord(record: Omit<MedicalRecord, 'id' | 'createdAt' | 'updatedAt'>): MedicalRecord {
    const newRecord: MedicalRecord = {
      ...record,
      id: Date.now().toString(),
      createdAt: new Date(),
      updatedAt: new Date()
    };
    this.records.update(records => [...records, newRecord]);
    return newRecord;
  }

  updateRecord(id: string, updates: Partial<MedicalRecord>): void {
    this.records.update(records =>
      records.map(r =>
        r.id === id ? { ...r, ...updates, updatedAt: new Date() } : r
      )
    );
  }

  deleteRecord(id: string): void {
    this.records.update(records => records.filter(r => r.id !== id));
  }
}

